// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1IkQM","title":"Info_title__1gkVZ","selects":"Info_selects__Ly-P2","requiredAsterisk":"Info_requiredAsterisk__1R0DS"};